module.exports = __webpack_public_path__ + "img/code-analysis.8790736a.webp";